import Tool from '../../common/tool';
var OperateMain = /** @class */ (function () {
    function OperateMain() {
        this.headerDom = document.getElementById('kingshiper-header');
        this.secondaryHeaderDom = document.getElementById('kingshiper-secondary-header');
        this.footerDom = document.getElementById('kingshiper-footer');
        this.searchBoxDom = document.getElementById('search');
        this.operateDom = document.getElementById('operate');
        this.articleDom = document.getElementById('operate-right');
        this.init();
    }
    OperateMain.prototype.init = function () {
        this.handleSearch();
        this.handleAnchor();
        this.handleFixed();
        this.handleArrow();
        this.handleShare();
    };
    OperateMain.prototype.handleSearch = function () {
        var that = this;
        var inputDom = this.searchBoxDom.querySelector('.search-input');
        var searchBtnDom = this.searchBoxDom.querySelector('.search-btn');
        var searchClearDom = this.searchBoxDom.querySelector('.search-clear');
        var syncClearVisible = function () {
            var inputVal = inputDom.value.trim();
            if (inputVal !== '') {
                searchClearDom.classList.add('active');
            }
            else {
                searchClearDom.classList.remove('active');
            }
        };
        searchBtnDom.addEventListener('click', function (e) {
            var inputVal = inputDom.value.trim();
            if (inputVal !== '') {
                that.confirmSearch(inputDom);
            }
            else {
                that.resetTitleBox();
            }
            e.stopPropagation();
        });
        inputDom.addEventListener('keyup', function (e) {
            syncClearVisible();
            var inputVal = inputDom.value.trim();
            if (inputVal !== '' && (e.keyCode === 13 || e.key === 'Enter')) {
                that.confirmSearch(inputDom);
            }
            if (inputVal === '') {
                that.resetTitleBox();
            }
            e.stopPropagation();
        });
        inputDom.addEventListener('input', function () {
            syncClearVisible();
            if (inputDom.value.trim() === '') {
                that.resetTitleBox();
            }
        });
        searchClearDom.addEventListener('click', function (e) {
            inputDom.value = '';
            searchClearDom.classList.remove('active');
            that.resetTitleBox();
            e.stopPropagation();
        });
    };
    OperateMain.prototype.confirmSearch = function (inputDom) {
        var that = this;
        that.resetTitleBox();
        var inputVal = inputDom.value.trim();
        if (inputVal != '') {
            var flag_1 = false;
            var h1Doms = Tool.$_selectAll(that.operateDom, '.h1');
            var h2Doms = Tool.$_selectAll(that.operateDom, '.h2');
            var h3Doms = Tool.$_selectAll(that.operateDom, '.h3');
            var h4Doms = Tool.$_selectAll(that.operateDom, '.h4');
            var domArr = [h1Doms, h2Doms, h3Doms, h4Doms];
            for (var _i = 0, domArr_1 = domArr; _i < domArr_1.length; _i++) {
                var hDom = domArr_1[_i];
                hDom.forEach(function (item) {
                    var titleText = item.innerText;
                    if (!titleText.includes(inputVal)) {
                        item.classList.add('hide');
                    }
                    else {
                        flag_1 = true;
                        var str = inputVal.replace(/[-\/\\^$.*+?()[\]{}|]/g, '\\$&'); // 转义正则表达式中的特殊字符
                        var reg = new RegExp(str, 'g');
                        var highlight = "<span>".concat(inputVal, "</span>");
                        var highlightStr = titleText.replace(reg, highlight);
                        item.children[0].innerHTML = highlightStr;
                        // 处理搜索前收起H2-H4，搜索后不显示的问题
                        var isMatchH1 = item.classList.contains('h1');
                        if (!isMatchH1) {
                            var foldRange = item.closest('.fold-range');
                            var h1Row = foldRange === null || foldRange === void 0 ? void 0 : foldRange.previousElementSibling;
                            var arrowBtn = h1Row === null || h1Row === void 0 ? void 0 : h1Row.children[1];
                            if (arrowBtn === null || arrowBtn === void 0 ? void 0 : arrowBtn.classList.contains('fold')) {
                                arrowBtn.click();
                            }
                        }
                    }
                });
            }
            if (!flag_1) { // 未搜索到内容，显示缺省图
                var emptyBox = Tool.$_select(that.searchBoxDom, '.empty-box');
                var operateTitleBox = Tool.$_select(that.searchBoxDom, '.operate-title-box');
                emptyBox.classList.add('active');
                operateTitleBox.classList.add('hide');
            }
        }
        else {
            alert('关键词不能为空！');
        }
    };
    OperateMain.prototype.resetTitleBox = function () {
        var that = this;
        var emptyBox = Tool.$_select(that.searchBoxDom, '.empty-box');
        var operateTitleBox = Tool.$_select(that.searchBoxDom, '.operate-title-box');
        emptyBox.classList.remove('active');
        operateTitleBox.classList.remove('hide');
        var h1Doms = Tool.$_selectAll(that.operateDom, '.h1');
        var h2Doms = Tool.$_selectAll(that.operateDom, '.h2');
        var h3Doms = Tool.$_selectAll(that.operateDom, '.h3');
        var h4Doms = Tool.$_selectAll(that.operateDom, '.h4');
        var domArr = [h1Doms, h2Doms, h3Doms, h4Doms];
        for (var _i = 0, domArr_2 = domArr; _i < domArr_2.length; _i++) {
            var hDom = domArr_2[_i];
            hDom.forEach(function (item) {
                item.classList.remove('hide');
                var titleText = item.innerText;
                item.children[0].innerHTML = titleText;
            });
        }
    };
    OperateMain.prototype.handleAnchor = function () {
        var that = this;
        var h1Doms = Tool.$_selectAll(that.operateDom, '.h1');
        var h2Doms = Tool.$_selectAll(that.operateDom, '.h2');
        var h3Doms = Tool.$_selectAll(that.operateDom, '.h3');
        var h4Doms = Tool.$_selectAll(that.operateDom, '.h4');
        var domArr = [h1Doms, h2Doms, h3Doms, h4Doms];
        for (var _i = 0, domArr_3 = domArr; _i < domArr_3.length; _i++) {
            var hDom = domArr_3[_i];
            hDom.forEach(function (item) {
                item.addEventListener('click', function () {
                    var _a;
                    clearTimeout(timer);
                    var clearActiveDom = Tool.$_selectAll(that.operateDom, '.clear-active');
                    clearActiveDom.forEach(function (cItem) { return cItem.classList.remove('active'); });
                    item.classList.add('active');
                    var dataHref = (_a = item.children[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('data-href');
                    if (!dataHref) {
                        return;
                    }
                    var aNameDom = that.resolveContentAnchor(dataHref);
                    if (!aNameDom) {
                        return;
                    }
                    window.scrollTo({
                        left: 0,
                        top: aNameDom.getBoundingClientRect().top + window.scrollY - 92,
                        behavior: "smooth"
                    });
                    history.pushState(null, '', "#".concat(dataHref));
                });
            });
        }
        // 初始进入页面，获取哈希值自动滚动到相应位置
        // 一定要加定时器，不然定位会出错
        var timer = setTimeout(function () {
            that.gotoFixedPosition();
        }, 700);
        window.addEventListener('hashchange', function () {
            that.gotoFixedPosition();
        });
    };
    /** 正文区锚点：优先 name，其次 id */
    OperateMain.prototype.resolveContentAnchor = function (anchorId) {
        var _a, _b, _c;
        var contentBox = Tool.$_select(this.articleDom, '.operate-content-box');
        return ((_c = (_b = (_a = contentBox.querySelector("a[name=\"".concat(anchorId, "\"]"))) !== null && _a !== void 0 ? _a : contentBox.querySelector("#".concat(CSS.escape(anchorId)))) !== null && _b !== void 0 ? _b : document.getElementsByName(anchorId)[0]) !== null && _c !== void 0 ? _c : document.getElementById(anchorId));
    };
    OperateMain.prototype.gotoFixedPosition = function () {
        var urlHash = window.location.hash;
        if (urlHash === '') {
            return;
        }
        var targetName = urlHash.substring(1);
        var tocLink = this.searchBoxDom.querySelector("a[data-href=\"".concat(targetName, "\"]"));
        var tocHeading = tocLink === null || tocLink === void 0 ? void 0 : tocLink.closest('.h1, .h2, .h3, .h4');
        if (tocHeading) {
            tocHeading.click();
            return;
        }
        var anchor = this.resolveContentAnchor(targetName);
        if (!anchor) {
            return;
        }
        window.scrollTo({
            left: 0,
            top: anchor.getBoundingClientRect().top + window.scrollY - 92,
            behavior: 'smooth',
        });
    };
    OperateMain.prototype.handleFixed = function () {
        var that = this;
        window.addEventListener('scroll', function () {
            var operateLeft = Tool.$_select(that.operateDom, '.operate-left-fixed');
            // 文档总高
            var documentH = document.body.clientHeight;
            // 当前元素到文档顶部距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var toDocumentH = operateLeft.offsetTop + scrollTop;
            // 当前元素高度
            var operateLeftH = operateLeft.offsetHeight;
            // 当前元素距离文档底部距离(挺准的~)
            var toDocumentBottomH = documentH - toDocumentH - operateLeftH;
            if (scrollTop >= 90 && toDocumentBottomH >= 490) {
                operateLeft.classList.add('fixed');
            }
            else {
                operateLeft.classList.remove('fixed');
            }
        });
    };
    OperateMain.prototype.handleArrow = function () {
        var that = this;
        var arrowDom = Tool.$_selectAll(that.operateDom, '.arrow');
        arrowDom.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.stopPropagation();
                var hasFoldClass = item.classList.contains('fold');
                var dataFoldClass = item.getAttribute('data-fold-class');
                var foldRangeDom = Tool.$_select(that.operateDom, ".".concat(dataFoldClass));
                if (!hasFoldClass) {
                    item.classList.add('fold');
                    foldRangeDom.classList.add('hide');
                }
                else {
                    item.classList.remove('fold');
                    foldRangeDom.classList.remove('hide');
                }
            });
        });
    };
    // 实现分享交互2025-4-29
    // 复制链接功能、两个显示二维码（QQ-WX）、两个点击跳转分享网页(QQ-WB)
    OperateMain.prototype.handleShare = function () {
        var share_boxDom = this.articleDom.querySelector('.share-box');
        if (!share_boxDom || getComputedStyle(share_boxDom).display === 'none') {
            return;
        }
        var titleDom = Tool.$_select(this.articleDom, '.operate-right-text');
        var success_tipDom = Tool.$_select(this.articleDom, '.copy-success');
        var copy_btnDom = Tool.$_select(share_boxDom, '.copy-btn');
        //const qq_shareDom = Tool.$_select(share_boxDom, '.qq-share');
        //const wechat_shareDom = Tool.$_select(share_boxDom, '.wx-share');
        var weibo_shareDom = Tool.$_select(share_boxDom, '.weibo-share');
        var qq_zoneDom = Tool.$_select(share_boxDom, '.qq-zone');
        var qr_codeDom = Tool.$_selectAll(share_boxDom, '.qr-code');
        var title = titleDom.innerText;
        var currentUrl = window.location.href;
        var encodedUrl = encodeURIComponent(currentUrl);
        if (share_boxDom && copy_btnDom) {
            copy_btnDom.addEventListener('click', function () {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(currentUrl).then(function () {
                        success_tipDom.classList.add('active');
                        setTimeout(function () {
                            success_tipDom.classList.remove('active');
                        }, 2000); // 2秒后移除提示
                    }).catch(function (err) {
                        console.error('复制失败：', err);
                    });
                }
                else {
                    var textarea = document.createElement('textarea');
                    textarea.value = currentUrl;
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        var successful = document.execCommand('copy');
                        if (successful) {
                            success_tipDom.classList.add('active');
                            setTimeout(function () {
                                success_tipDom.classList.remove('active');
                            }, 2000); // 2秒后移除提示
                        }
                    }
                    catch (error) {
                        console.error('复制失败：', error);
                    }
                    document.body.removeChild(textarea);
                }
            });
            // 调用函数生成二维码
            if (typeof createQrcode === 'function') {
                qr_codeDom.forEach(function (item) {
                    createQrcode(item, currentUrl);
                });
            }
            qq_zoneDom === null || qq_zoneDom === void 0 ? void 0 : qq_zoneDom.setAttribute('href', "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=".concat(encodedUrl, "&title=").concat(title));
            weibo_shareDom === null || weibo_shareDom === void 0 ? void 0 : weibo_shareDom.setAttribute('href', "https://service.weibo.com/share/share.php?url=".concat(encodedUrl, "&title=").concat(title));
        }
    };
    return OperateMain;
}());
export default OperateMain;
